export const rounded = (val) => parseFloat(val).toFixed(2)
